export default __webpack_public_path__ + "static/media/09.ee2e2415.jpg";